import {
    useCallback,
    useEffect,
    useMemo,
    useState
} from 'react';
import {
    ConfigParametersTemplates,
    Modal,
    Search,
    Tab,
    Tabs
} from '../../components';
import {
    getCategoryTemplate,
    getMsgTemplate
} from '../../service/serviceChat/chatService';
import {
    Container,
    EmptyState,
    FiltersType,
    TextMessage,
    TypeTemplate,
    ViewMessage
} from './styled';

const TYPE_TEMPLATE = {
    MARKETING: 'MARKETING',
    UTILITY: 'UTILITY',
    ALL: 'ALL'
};

const FILTER_BUTTONS = [
    { key: TYPE_TEMPLATE.ALL, label: 'Todos', className: 'dfl', description: '' },
    { key: TYPE_TEMPLATE.UTILITY, label: 'Utilitários', className: 'uly', description: '' },
    { key: TYPE_TEMPLATE.MARKETING, label: '* Marketing', className: 'mkt', description: '*O WhatsApp não garante a entrega.' }
];

export function MessageTemplates(props) {
    const {
        isTemplatesOpenSession = false,
        onChange,
        className,
        width,
        height
    } = props;

    const [templates, setTemplates] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [textSearch, setTextSearch] = useState('');
    const [isTemplateParameter, setIsTemplateParameter] = useState({});
    const [filterTemplate, setFilterTemplate] = useState(TYPE_TEMPLATE.ALL);

    const fetchData = useCallback(async () => {
        try {
            const [resCategory, resTemplate] = await Promise.all([
                getCategoryTemplate('WHATSAPP'),
                getMsgTemplate('WHATSAPP')
            ]);

            setCategory(resCategory || []);
            setTemplates(resTemplate?.map(template => ({
                ...template,
                categoria: template.categoria || ''
            })) || []);
        } catch (error) {
            console.error('Error fetching templates:', error);
            setCategory([]);
            setTemplates([]);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const filteredTemplates = useMemo(() => {
        if (!templates.length) return [];

        const lowerCaseSearch = textSearch?.toLowerCase() || '';
        const lowerCaseCategory = selectedCategory?.toLowerCase() || '';

        return templates.filter(template => {
            const matchesText = !lowerCaseSearch ||
                template?.text?.toLowerCase()?.includes(lowerCaseSearch);
            const matchesCategory = !lowerCaseCategory ||
                template?.categoria?.toLowerCase()?.includes(lowerCaseCategory);

            const matchesType = isTemplatesOpenSession
                ? (filterTemplate === TYPE_TEMPLATE.ALL || template?.waba_template_category === filterTemplate)
                : (template?.utiliza_botoes
                    ? (filterTemplate === TYPE_TEMPLATE.ALL || template?.waba_template_category === filterTemplate)
                    : filterTemplate === TYPE_TEMPLATE.ALL);

            return matchesText && matchesCategory && matchesType;
        });
    }, [templates, textSearch, selectedCategory, filterTemplate, isTemplatesOpenSession]);

    const handleTemplateClick = useCallback((template) => {
        if (template?.qtd_params > 0) {
            setIsTemplateParameter(template);
        } else {
            onChange(template);
        }
    }, [onChange]);

    const handleParameterModalClose = useCallback(() => {
        setIsTemplateParameter({});
    }, []);

    const handleParameterChange = useCallback((template) => {
        onChange(template);
        setIsTemplateParameter({});
    }, [onChange]);

    const renderTemplateIcon = useCallback((template) => {
        if (!template?.waba_template_category || (!isTemplatesOpenSession && !template?.utiliza_botoes)) {
            return <TypeTemplate.DEFAULT />;
        }
        if (template.waba_template_category === TYPE_TEMPLATE.MARKETING) {
            return <TypeTemplate.MARKETING />;
        }
        if (template.waba_template_category === TYPE_TEMPLATE.UTILITY) {
            return <TypeTemplate.UTILITY />;
        }
        return null;
    }, [isTemplatesOpenSession]);

    const isModalOpen = Boolean(isTemplateParameter?.qtd_params > 0);

    return (
        <>
            <Container
                className={className}
                width={width}
                height={height}
            >
                <Search
                    className='input--search'
                    value={textSearch}
                    onChange={(e) => setTextSearch(e.target.value)}
                />
                <FiltersType>
                    {FILTER_BUTTONS.map(({ key, label, className: btnClassName, description }) => (
                        <>
                            <button
                                key={key}
                                className={`${btnClassName} ${filterTemplate === TYPE_TEMPLATE[key] ? `${btnClassName}-sel` : ''}`}
                                onClick={() => setFilterTemplate(TYPE_TEMPLATE[key])}
                            >
                                {label}
                            </button>
                            {description && <span className={`${btnClassName}-description`}>{`- ${description}`}</span>}
                        </>
                    ))}
                </FiltersType>
                <Tabs>
                    <Tab
                        className={selectedCategory === '' ? 'selected' : ''}
                        onClick={() => setSelectedCategory('')}
                    >
                        Todos
                    </Tab>
                    {category.map((categoryItem, index) => (
                        <Tab
                            key={`${categoryItem}-${index}`}
                            className={selectedCategory === categoryItem ? 'selected' : ''}
                            onClick={() => setSelectedCategory(categoryItem)}
                        >
                            {categoryItem}
                        </Tab>
                    ))}
                </Tabs>
                <ViewMessage>
                    {filteredTemplates.length > 0 ? (
                        filteredTemplates.map((template) => (
                            <TextMessage
                                key={template?.id}
                                onClick={() => handleTemplateClick(template)}
                            >
                                {renderTemplateIcon(template)}
                                {template?.text}
                            </TextMessage>
                        ))
                    ) : (
                        <EmptyState>
                            <TypeTemplate.MARKETING />
                            <h3>Nenhum template encontrado</h3>
                            <p>Tente ajustar os filtros ou categorias para encontrar templates disponíveis.</p>
                        </EmptyState>
                    )}
                </ViewMessage>
            </Container>
            {isModalOpen && (
                <Modal
                    title="Preencha todos os campos abaixo"
                    isOpen={isModalOpen}
                    close={handleParameterModalClose}
                >
                    <ConfigParametersTemplates
                        template={isTemplateParameter}
                        onChange={handleParameterChange}
                        close={handleParameterModalClose}
                    />
                </Modal>
            )}
        </>
    );
}           